// src/components/FlowCreatures.jsx
import React from 'react';
import SwimmingBlackPiranha from './BlackPiranha.jsx';
import SwimmingRedTailCatfish from './RedTailCatfish.jsx';
import SwimmingSlobberingCatfish from './SlobberingCatfish.jsx';
import SwimmingPayara from './Payara.jsx';

// Robust boolean-ish env parser; defaults to true unless explicitly off
const boolEnv = (key, defaultVal = true) => {
    const raw = process.env[key];
    if (raw == null) return defaultVal;
    const v = String(raw).trim().toLowerCase();
    if (['1', 'true', 'yes', 'on'].includes(v)) return true;
    if (['0', 'false', 'no', 'off', ''].includes(v)) return false;
    return defaultVal;
};

export default function FlowCreatures({
    zone,
    theme, // kept for parity
    onCreatureClick,
    highlightVersion,
}) {
    const isHighlighted = (versionNumber) =>
        highlightVersion != null && String(versionNumber) === String(highlightVersion);

    // NEW: species-level flags
    const showBlackPiranha = boolEnv('REACT_APP_SHOW_BLACK_PIRANHA', true);
    const showRedTailCatfish = boolEnv('REACT_APP_SHOW_RED_TAIL_CATFISH', true);
    const showSlobberingCatfish = boolEnv('REACT_APP_SHOW_SLOBBERING_CATFISH', true);
    const showPayara = boolEnv('REACT_APP_SHOW_PAYARA', true);

    // versions: 0 = Black Piranha, 1 = Red Tail Catfish (adjust if your data differs)
    const v0 = zone?.versions?.[0];
    const v1 = zone?.versions?.[1];
    const v2 = zone?.versions?.[2];
    const v3 = zone?.versions?.[3];

    const handleClick = (v, name) => {
        if (onCreatureClick) onCreatureClick(v);
        else console.warn(`[FlowCreatures] onCreatureClick missing; clicked ${name}`, v);
    };

    return (
        <section className="relative w-full h-64 overflow-visible">
            {/* Red Tail Catfish (lower lane) */}
            {showRedTailCatfish && v1 && (
                <SwimmingRedTailCatfish
                    width={120}
                    swimDuration="70s"
                    minTop={80}
                    maxTop={100}
                    zIndex={25}
                    highlight={isHighlighted(v1.versionNumber)}
                    onClick={() => handleClick(v1, 'RedTailCatfish')}
                />
            )}

            {/* Black Piranha (mid lane) */}
            {showBlackPiranha && v0 && (
                <SwimmingBlackPiranha
                    width={100}
                    swimDuration="40s"
                    minTop={40}
                    maxTop={70}
                    zIndex={20}
                    highlight={isHighlighted(v0.versionNumber)}
                    onClick={() => handleClick(v0, 'BlackPiranha')}
                />
            )}

            {/* Slobbering Catfish */}
            {showSlobberingCatfish && v2 && (
                <SwimmingSlobberingCatfish
                    width={100}
                    swimDuration="30s"
                    zIndex={30}
                    highlight={isHighlighted(v2.versionNumber)}
                    onClick={() => handleClick(v2, 'SlobberingCatfish')}
                />
            )}

                        {/* Payara */}
            {showPayara && v3 && (
                <SwimmingPayara
                    width={100}
                    swimDuration="50s"
                    zIndex={30}
                    highlight={isHighlighted(v3.versionNumber)}
                    onClick={() => handleClick(v3, 'Payara')}
                />
            )}
        </section>
    );
}
